/**
 * DataLayer updater for Booking on /rezerwacja
 */
export default class Booking {
  formSubmissionSuccess () {
    window.dataLayer.push({ event: 'formSubmissionSuccess', formId: 'reservationForm' })
  }

  formSubmissionFailed () {
    window.dataLayer.push({ event: 'formSubmissionFailed', formId: 'reservationForm' })
  }
}



// WEBPACK FOOTER //
// ./src/modules/datalayer/Booking.js